"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditKeyValueColumn = exports.RenderKeyValueColumn = void 0;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var RenderKeyValueColumn = function (props) { return (React.createElement("div", { className: 'element-row key-value-column' },
    React.createElement("div", null,
        React.createElement("b", null, props.element.key)),
    React.createElement("div", null, props.element.value))); };
exports.RenderKeyValueColumn = RenderKeyValueColumn;
var EditKeyValueColumn = function (props) { return (React.createElement("div", { className: 'element key-value-column' },
    React.createElement("div", { className: 'key' },
        React.createElement("label", null, (0, translation_1.getLocalization)('dashboardElements/modal/key')),
        React.createElement(sok_ui_1.TextInput, { value: props.element.key, placeholder: (0, translation_1.getLocalization)('dashboardElements/modal/addkey'), disabled: props.saveStatus === 'FETCHING', onChange: function (_a) {
                var value = _a.target.value;
                return props.updateElement(props.i, 'key', value);
            } }),
        props.errors !== null && props.errors["element-".concat(props.i, "-key")] && (React.createElement("p", { className: 'validation-error' }, props.errors["element-".concat(props.i, "-key")][0]))),
    React.createElement("div", null,
        React.createElement("div", { className: 'value' },
            React.createElement("label", null, (0, translation_1.getLocalization)('dashboardElements/modal/value')),
            React.createElement(sok_ui_1.TextInput, { value: props.element.value, placeholder: (0, translation_1.getLocalization)('dashboardElements/modal/addValue'), disabled: props.saveStatus === 'FETCHING', onChange: function (_a) {
                    var value = _a.target.value;
                    return props.updateElement(props.i, 'value', value);
                } }),
            props.errors !== null && props.errors["element-".concat(props.i, "-value")] && (React.createElement("p", { className: 'validation-error' }, props.errors["element-".concat(props.i, "-value")][0]))),
        React.createElement("div", { className: 'remove', onClick: function () {
                return props.saveStatus !== 'FETCHING' && props.removeElement(props.i);
            } },
            React.createElement(sok_ui_1.Icon, { className: 'fa-times-circle' }))))); };
exports.EditKeyValueColumn = EditKeyValueColumn;
